<h2 mat-dialog-title>Rooster versturen</h2>
<mat-dialog-content>
  <mat-form-field class="full-width">
    <mat-label>Periode</mat-label>
    <mat-select [value]="period()" (selectionChange)="period.set($event.value)">
      <mat-option value="tomorrow">Morgen</mat-option>
      <mat-option value="nextWeek">Volgende week</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="full-width">
    <mat-label>Rollen</mat-label>
    <mat-select multiple [value]="selectedRoles()" (selectionChange)="selectedRoles.set($event.value)">
      @for (role of roles; track role.value) {
        <mat-option [value]="role.value">{{ role.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="loading()">Annuleren</button>
  <button mat-flat-button [class.spinner]="loading()" (click)="sendSchedule()" [disabled]="!canSend() || loading()">
    Versturen
  </button>
</mat-dialog-actions>
